import { Modal } from 'react-bootstrap'
import { COLORS } from 'src/styles/theme'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  #btn {
    font-family: 'Din', 'DIN', sans-serif;
    font-size: inherit;
    color: #374151;
    white-space: nowrap;

    .highlight {
      font-weight: 700;
      color: #262c65;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`
export const ForgetPasswordModal = styled(Modal)`
  .modal-content {
    color: #404040;
    border: none;
    padding: 16px;

    .modal-title {
      text-align: center;
    }
    .modal-body {
      padding-bottom: 0;
    }
    label {
      padding: 4px 0px;
    }
    input {
      border-radius: 4px;
      background: ${COLORS.lightGray};
      padding: 4px 12px;
      font-size: 13px;
      &::placeholder {
        font-size: 13px;
      }
    }
    /* Canonical button style — matches the login page submit button
       (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
       consistency across the app. Scoped to this modal only (rather
       than overriding the shared global '.c-button' class in
       src/index.css) so the many other unrelated '.c-button' usages
       elsewhere in the app are left untouched. */
    button#verify-btn {
      display: block;
      margin: 0 auto;
      border: none;
      font-weight: 500;
      font-size: 14px;
      padding: 6px 18px;
      background: var(--Gold-Gradient-01);
      color: #fff !important;
      border-radius: 10px;
      box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
    }
  }
  .modal-header {
    border: none;
    padding: 0 16px;
  }
`
